// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tc8T4","tabsBox":"styles_tabsBox__4WRKB","createButton":"styles_createButton__3RRiQ"};